import React from "react";
import { FormGroup, FormGroupVerticalInput, TextInput } from "..";
import { getInputErrorMessage, hasErrorInput, SelectUtils } from "../../utils";
import Select2 from "../Select2";

const SearchTabs = ({
  name,
  groupSettings,
  errors,
  dataSearch,
  setDataSearch,
  machineOptions
}) => {
  return (
    <div className="border w-fit h-auto border-[#BDBDBD] lg:px-5 px-3 pt-4">
      <FormGroup direction="horizontal">
        <label className="lg:min-w-[100px] min-w-[80px] py-2 whitespace-nowrap w-fit lg:mr-4 mr-2">
          {groupSettings["machine"]?.name}
        </label>
        <FormGroupVerticalInput error={getInputErrorMessage(errors, name)}>
          {name === "machine_name" ? (
            <TextInput
              value={dataSearch.machine_name}
              hasError={hasErrorInput(errors, "machine_name")}
              className="lg:w-[280px] w-[260px]"
              name="machine_name"
              onChange={(e) =>
                setDataSearch({ ...dataSearch, machine_name: e.target.value })
              }
              maxLength="200"
            />
          ) : (
            <Select2
              options={machineOptions}
              value={SelectUtils.getSelectedValueFilter(
                machineOptions,
                dataSearch.machine_id,
                true
              )}
              hasError={hasErrorInput(errors, "machine_id")}
              classNamePrefix="react-select"
              className="lg:w-[280px] w-[260px]"
              onChange={(e) =>
                setDataSearch({ ...dataSearch, machine_id: e.value })
              }
              maxLength="200"
            />
          )}
        </FormGroupVerticalInput>
      </FormGroup>
    </div>
  );
};

export default SearchTabs;
